import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "daster",
  style: {"padding":"0 30px"}
}
const _hoisted_2 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title mb-4" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mb-0 text-fprimary" }, "Instituciones"),
  /*#__PURE__*/_createElementVNode("span", null, "Permite administrar las instituciones registradas")
], -1)
const _hoisted_4 = { class: "options" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-building-add fs-2 me-2 text-white" }, null, -1)
const _hoisted_6 = { class: "d-flex justify-content-between align-items-end mb-6" }
const _hoisted_7 = { class: "card-title d-flex align-items-end" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search" }, null, -1)
const _hoisted_9 = { class: "card-toolbar d-flex" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "d-block fw-bold" }, "Categoría", -1)
const _hoisted_12 = { class: "col" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "d-block fw-bold" }, "Ámbito", -1)
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = {
  class: "text-dark-50 text-hover-primary cursor-pointer",
  style: {"line-height":"1.25"}
}
const _hoisted_16 = {
  key: 0,
  class: "fw-bold"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_19 = { class: "d-flex" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-gear-fill fs-2 p-0" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_AddEdit = _resolveComponent("AddEdit")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.onRegister
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode("Registrar ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.textSearch,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.textSearch) = $event)),
            class: "w-350px",
            placeholder: "Buscar...",
            clearable: "",
            onKeypress: _withKeys(_ctx.getData, ["enter"]),
            onClear: _ctx.getData
          }, {
            append: _withCtx(() => [
              _createVNode(_component_el_tooltip, {
                class: "box-item",
                effect: "dark",
                content: "Buscar",
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.getData
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onKeypress", "onClear"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_el_select, {
              modelValue: _ctx.filter.category,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter.category) = $event)),
              clearable: "",
              multiple: "",
              "collapse-tags": "",
              class: "me-4 w-250px",
              placeholder: "Todos",
              onChange: _ctx.getData
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.setting.categories, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.iddetails,
                    label: item.name,
                    value: item.iddetails
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_el_select, {
              modelValue: _ctx.filter.type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filter.type) = $event)),
              clearable: "",
              class: "me-4 w-150px",
              placeholder: "Todos",
              onChange: _ctx.getData
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.setting.types, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.iddetails,
                    label: item.name,
                    value: item.iddetails
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ])
        ])
      ]),
      (_ctx.listClubs.length > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: _ctx.listClubs,
              border: "",
              "table-layout": 'auto'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "idinstitution",
                  label: "ID",
                  width: "80",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "persona",
                  label: "Institución"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_el_avatar, {
                        shape: "square",
                        size: 35,
                        fit: "contain",
                        src: '',
                        class: "border me-3"
                      }),
                      _createElementVNode("div", _hoisted_15, [
                        (scope.row.abrev)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(scope.row.abrev.toUpperCase()), 1))
                          : _createCommentVNode("", true),
                        _hoisted_17,
                        (scope.row.business)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(scope.row.business), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "category_name",
                  label: "Categoría"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "type_name",
                  label: "Ámbito"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "type_name",
                  label: "Afiliación"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(`badge badge-${scope.row.afiliate_class}`)
                    }, _toDisplayString(scope.row.afiliate_name), 3)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Estado",
                  width: "120",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", {
                      class: _normalizeClass('badge badge-' + scope.row.status_class)
                    }, _toDisplayString(scope.row.status_name), 3)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  width: "100",
                  label: "OP",
                  fixed: "right"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: "Editar",
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("i", {
                            class: "bi bi-pencil-fill fs-2 text-hover-primary me-4",
                            onClick: ($event: any) => (_ctx.onEdit(scope.row))
                          }, null, 8, _hoisted_20)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: "Eliminar",
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("i", {
                            class: "bi bi-trash fs-2 text-hover-danger me-4",
                            onClick: ($event: any) => (_ctx.onDelete(scope.row))
                          }, null, 8, _hoisted_21)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: "Configurar",
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: `/institutions/${scope.row.idinstitution}/repman`
                          }, {
                            default: _withCtx(() => [
                              _hoisted_22
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, _ctx.loader]
            ]),
            _createVNode(_component_el_pagination, {
              class: "mt-4",
              "current-page": _ctx.currentPage,
              "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentPage) = $event)),
              "page-size": _ctx.pageSize,
              "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pageSize) = $event)),
              "page-sizes": [100, 200, 300, 400],
              small: false,
              background: true,
              layout: "total, prev, pager, next",
              total: _ctx.totalItems,
              onCurrentChange: _ctx.handleCurrentChange
            }, null, 8, ["current-page", "page-size", "total", "onCurrentChange"])
          ], 64))
        : _withDirectives((_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            description: "No se encontrarón registros"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.getData
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Volver a intentar")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })), [
            [_directive_loading, _ctx.loader]
          ])
    ]),
    _createVNode(_component_AddEdit, {
      setting: _ctx.setting,
      onOnResponse: _ctx.onResponse,
      item: _ctx.rowItem
    }, null, 8, ["setting", "onOnResponse", "item"])
  ], 64))
}